import { config } from "core/config/app"

export const API_CART = `${config.apiPrefix}/${config.apiVersion}/carts`
export const API_COUNT_CART = `${config.apiPrefix}/${config.apiVersion}/carts/count`
